import { Button, Card, Divider, Loading, Option, Select, SingleDatePicker, TextInput, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import moment from "moment";
import React, { useEffect, useState } from 'react'
import { handleDateChange } from '../../util/handleDateChange';
import { helperTexts } from '../../util/helperTexts';
import { mmOrMiles } from '../../util/helperFunctions';
import { convertToDecimal, decimalRound, getImperialOnValue, getNameUnits, getNumericBase, getPowerExponent } from './utils/featureAnalysisUtils';
import useLatestPCRDate from './hooks/useLatestPCRDate';
import usePositionAndMaterial from './hooks/usePositionAndMaterial';
import useInitialData from './hooks/useInitialData';
import useFeatureIds from './hooks/useFeatureIds';
import useScenarioFeatures from './hooks/useScenarioFeatures';
import useFeatureStats from './hooks/useFeatureStats';
import { featureChangeHandler, predictHandler, submitForm } from './utils/featureAnalysisHandlers';

const helpContents = helperTexts.sensorFeatureAnalysis;

const SensorFeatureAnalysis = ({ units, start, end, sensorID, isRealSensor }) => {

    const [predictCRate, setPredictCRate] = useState(null);
    const [featureValueList, setFeatureValueList] = useState([]);
    const [scenarioFeatures, setscenarioFeatures] = useState(null);
    const [loadingPredictCR, setLoadingPredictCR] = useState(false);
    const [errorText, seterrorText] = useState([]);
    const precentageFeature = [];
    const [viscosityNumber, setViscosityNumber] = useState(0);
    const [viscosityPower, setViscosityPower] = useState(0);
    const [crDate, setCRDate] = useState(null);
    const [viscosityError, setViscosityError] = useState(null);

    const { changeFeatureList, featureList, materialOption, positionOption, setPositionAndMaterial } = usePositionAndMaterial(setFeatureValueList, setscenarioFeatures);
    const { latestPCRDate, fetchLatestPCRDate } = useLatestPCRDate(sensorID);
    const { corrosionRateData, setCorrosionRateData, fetchInitialData } = useInitialData(sensorID, start, end, latestPCRDate, setPositionAndMaterial);
    // const { featureIdList } = useFeatureIds(featureList);
    useScenarioFeatures(scenarioFeatures, units, setFeatureValueList)

    // const { featureMinMax, featureStdMinMax } = useFeatureStats(featureIdList, sensorID, units, seterrorText, setViscosityError);
    const featureMinMax = []
    const featureStdMinMax = []
    // Set Viscosity power and number
    useEffect(() => {
        if (scenarioFeatures) {
            const viscosityObj = scenarioFeatures.find((obj) => Object.keys(obj)[0] === "Viscosity");
            if (viscosityObj === undefined) return;
            let value = viscosityObj["Viscosity"];
            setViscosityNumber(getNumericBase(value, units))
            setViscosityPower(getPowerExponent(value, units))
        }
    }, [scenarioFeatures, units]);


    const loadingScreen = <div className='loading-container' role='status'><Loading /></div>

    return (
        <div className='sensor-analysis-container' id='sensor-feature-id-1'>
            <div className='sensor-analysis-header' id='sensor-feature-id-2'>

                <div className='sensor-analysis-header-actions' id='sensor-feature-id-9'>
                    <div className='sensor-analysis-date-wrapper' id='sensor-feature-id-10'>
                        <p className='data-label' id='sensor-feature-id-11'>Date</p>
                        <SingleDatePicker
                            id='sensor-feature-id-12'
                            generateConfig={momentGenerateConfig}
                            config="custom"
                            format="DD/MM/yyyy"
                            allowClear={false}
                            value={crDate ? moment(crDate) : latestPCRDate ? moment(latestPCRDate) : null}
                            onChange={(date) => {
                                handleDateChange(date, crDate, setCRDate, "DD/MM/yyyy")
                            }}
                        />
                    </div>
                    <Button id='sensor-feature-id-13' disabled={!crDate || crDate === "Invalid Date"}
                        onClick={() => submitForm(sensorID, setscenarioFeatures, setPredictCRate, crDate, setCorrosionRateData, setPositionAndMaterial)}>Update</Button>
                    <Button id='sensor-feature-id-14' onClick={() => {
                        setscenarioFeatures(null);
                        setCRDate(null);
                        fetchInitialData();
                        fetchLatestPCRDate();
                    }}>Reset</Button>
                    <Tooltip className='tooltip' placement='bottom' id='sensor-feature-id-95' overlay={<div id='sensor-feature-id-96' className='tooltip-content'>{helpContents.resetHelp}</div>} trigger={
                        <Button id='sensor-feature-id-97' data-testid="tooltip-btn" variant='transparent' size='large' iconOnly icon={<InfoCircle id='sensor-feature-id-98' />} />
                    } />
                </div>
            </div>
            <br />
            <div className='sensor-analysis-content' id='sensor-feature-id-15'>
                <Card bodyPadding={false} className='sensor-analysis-card' id='sensor-feature-id-16'>
                    <div className='sensor-analysis-card-header' id='sensor-feature-id-17'>
                        <div className="sensor-analysis-feature-header" id='sensor-feature-id-18'>
                            <div className='sensor-analysis-title'>
                                <h4 className='feature-label' id='sensor-feature-id-19'>Feature</h4>
                                <Tooltip className='tooltip' placement='bottom' id='sensor-feature-id-5' overlay={<div id='sensor-feature-id-6' className='tooltip-content'>{helpContents.featurePlot}</div>} trigger={
                                    <Button id='sensor-feature-id-7' variant='transparent' size='large' iconOnly icon={<InfoCircle id='sensor-feature-id-8' />} />
                                } />
                            </div>
                            <h4 className='feature-value' id='sensor-feature-id-20'>Value</h4>
                        </div>
                        <div className="sensor-analysis-edit-header" id='sensor-feature-id-21'>
                            <h4 id='sensor-feature-id-22'>Editor</h4>
                        </div>
                    </div>
                    <Divider direction='horizontal' id='sensor-feature-id-23' />
                    {!scenarioFeatures && loadingScreen}
                    {scenarioFeatures && <><div className='sensor-analysis-card-content' id='sensor-feature-id-24'>
                        <div className="sensor-analysis-feature-container" id='sensor-feature-id-25'>
                            {scenarioFeatures?.map((feature, index) => {
                                let key = Object.keys(feature)[0];
                                let value = Object.values(feature)[0];
                                return (
                                    <>
                                        <div className="sensor-analysis-feature" key={index} id='sensor-feature-id-26'>
                                            <p className='data-value feature-label' id='sensor-feature-id-27'>{getNameUnits(key, index, units, precentageFeature)}</p>

                                            <p className='data-value feature-value' id='sensor-feature-id-28'> {key === "Viscosity" ? (<span id='sensor-feature-id-29'>{getNumericBase(value, units)} x 10<sup id='sensor-feature-id-30'>{getPowerExponent(value, units)}</sup></span>) : value && typeof value !== "string"
                                                ? units
                                                    ? decimalRound(getImperialOnValue(
                                                        key,
                                                        value
                                                    ), key)
                                                    : decimalRound(value, key)
                                                : value}
                                            </p>
                                        </div>

                                    </>
                                )
                            })}
                        </div>
                        {featureValueList?.length > 0 && (
                            <div className='sensor-analysis-edit' id='sensor-feature-id-31'>
                                {scenarioFeatures?.map((col, index) => {
                                    return (
                                        Object.keys(col)[0].startsWith("Position") ||
                                            Object.keys(col)[0].startsWith("Material") ? (
                                            <div className='data-value feature-edit' key={index} id='sensor-feature-id-32'>
                                                <Select
                                                    id='sensor-feature-id-33'
                                                    value={featureValueList[index]}
                                                    onChange={(value) =>
                                                        featureChangeHandler(
                                                            value,
                                                            Object.keys(col)[0],
                                                            index,
                                                            featureMinMax, featureStdMinMax, setFeatureValueList, precentageFeature, seterrorText
                                                        )
                                                    }
                                                >
                                                    {Object.keys(col)[0].startsWith("Position")
                                                        ? positionOption?.map((obj) => (
                                                            <Option value={obj} key={obj} id='sensor-feature-id-34'>
                                                                {obj}
                                                            </Option>
                                                        ))
                                                        : materialOption?.map((obj) => (
                                                            <Option value={obj} key={obj} id='sensor-feature-id-35'>
                                                                {obj}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </div>
                                        ) : Object.keys(col)[0] === "Viscosity" ? (
                                            <div className='feature-edit'>
                                                <div className="viscosity-edit key={index}" id='sensor-feature-id-36'>
                                                    <TextInput
                                                        id='sensor-feature-id-37'
                                                        onChange={e => {
                                                            const value = e.target.value;
                                                            const findMinMax = featureMinMax.find((obj) => obj.path === "Viscosity");

                                                            let viscosity = convertToDecimal(value, viscosityPower);
                                                            if (viscosity !== 0 && viscosity.toFixed(3) === '0.000') {
                                                                const p = Math.abs(Math.floor(Math.log10(viscosity)));
                                                                viscosity = viscosity.toFixed(p);
                                                            }

                                                            if (viscosity < findMinMax?.min || viscosity > findMinMax?.max) {
                                                                // Show error
                                                                setViscosityError(`Value must be between ${findMinMax.min} and ${findMinMax.max}`);
                                                            } else {
                                                                setViscosityError(null);
                                                            }

                                                            setViscosityNumber(value);
                                                        }}
                                                        value={viscosityNumber}
                                                        type='number'
                                                        onWheel={(e) => e.currentTarget.blur()} // Prevent scroll behavior
                                                    />
                                                    <pre style={{ fontSize: "16px" }} id='sensor-feature-id-38'>x 10</pre>

                                                    <TextInput
                                                        id='sensor-feature-id-39'
                                                        className='power-input'
                                                        onChange={e => {
                                                            const value = e.target.value;
                                                            const findMinMax = featureMinMax.find((obj) => obj.path === "Viscosity");
                                                            let viscosity = convertToDecimal(viscosityNumber, value);
                                                            if (viscosity !== 0 && viscosity.toFixed(3) === '0.000') {
                                                                const p = Math.abs(Math.floor(Math.log10(viscosity)));
                                                                viscosity = viscosity.toFixed(p);
                                                            }
                                                            if (viscosity < findMinMax?.min || viscosity > findMinMax?.max) {
                                                                // Show error
                                                                setViscosityError(`Value must be between ${findMinMax.min} and ${findMinMax.max}`);
                                                            } else {
                                                                setViscosityError(null);
                                                            }

                                                            setViscosityPower(value);
                                                        }}
                                                        value={viscosityPower}
                                                        type="number"
                                                        onWheel={(e) => e.currentTarget.blur()} // Prevent scroll behavior
                                                    />
                                                </div>
                                                <div>
                                                    {isRealSensor && viscosityError && (
                                                        <p className={viscosityError.includes("Model") ? "data-label info-label viscosity-label" : "data-label error-label viscosity-label"}>
                                                            {viscosityError}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="feature-edit" key={index} id='sensor-feature-id-40'>
                                                <TextInput
                                                    id='sensor-feature-id-41'
                                                    data-testid="text-input"
                                                    type='number'
                                                    onChange={(e) =>
                                                        featureChangeHandler(
                                                            e.target.value,
                                                            Object.keys(col)[0],
                                                            index,
                                                            featureMinMax, featureStdMinMax, setFeatureValueList, precentageFeature, seterrorText
                                                        )
                                                    }
                                                    value={featureValueList[index]}
                                                    onWheel={(e) => e.currentTarget.blur()} // Prevent scroll behavior
                                                />
                                                {isRealSensor && errorText && (
                                                    <p id='sensor-feature-id-42' className={errorText[index]?.includes("Model") ? "data-label info-label" : "data-label error-label"}>
                                                        {errorText[index]}
                                                    </p>
                                                )}
                                            </div>
                                        )
                                    );
                                }
                                )}
                            </div>
                        )}
                    </div>
                        <br />
                        <Divider direction='horizontal' id='sensor-feature-id-43' />
                        <div className='sensor-analysis-card-footer' id='sensor-feature-id-44'>
                            <div className='predicted-cr' id='sensor-feature-id-45'>
                                <p className='data-label' id='sensor-feature-id-46'>Predicted Corrosion Rate</p>
                                <p className='data-value' id='sensor-feature-id-47'>     {units
                                    ? decimalRound(39.3700787402 * corrosionRateData)
                                    : decimalRound(corrosionRateData)}{" "}
                                    {mmOrMiles(units)}</p>
                            </div>

                            {(predictCRate !== null && predictCRate !== undefined) &&
                                <div className="analysis-cr" id='sensor-feature-id-48'>
                                    <p className='data-label' id='sensor-feature-id-49'>Analysis Corrosion Rate</p>
                                    <p className='data-value' id='sensor-feature-id-50'>{units
                                        ? decimalRound(39.3700787402 * predictCRate)
                                        : decimalRound(predictCRate)}{" "}
                                        {mmOrMiles(units)}</p>
                                </div>
                            }
                            <Button
                                id='sensor-feature-id-51'
                                onClick={() => predictHandler(sensorID, units, setLoadingPredictCR, setPredictCRate, changeFeatureList, scenarioFeatures, featureValueList, viscosityNumber, viscosityPower)}
                                loading={loadingPredictCR}

                            >
                                Predict
                            </Button>
                        </div>
                    </>
                    }
                </Card>
            </div>
        </div>
    )
}

export default SensorFeatureAnalysis